export default function bem(...args) {
  const name = args.shift();
  if (typeof name !== 'string' || name === '') {
    return '';
  }
  const classes = [name];
  let el;
  for (let i = 0; i < args.length; i += 1) {
    el = args[i];
    if (el && typeof el === 'string') {
      classes.push(`${name}--${el}`);
    }
  }
  return classes.join(' ');
}
